
import { computed, defineComponent, PropType } from "vue";
import Icon, { Icons } from "./Icon.vue";
type Gender = "Male" | "Female" | "unknown" | "Genderless";

const genderIcons: Record<Gender, Icons> = {
  Male: "male",
  Female: "female",
  unknown: "remove",
  Genderless: "close",
};

export default defineComponent({
  name: "Gender",
  props: {
    gender: {
      type: String as PropType<Gender>,
      required: true,
    },
  },
  setup(props) {
    const genderIcon = computed(() => genderIcons[props.gender]);

    return { genderIcon };
  },
  components: { Icon },
});
